<script setup lang="ts">
import { computed } from 'vue';
import ActiveBenchmarkProgram from './ActiveBenchmarkProgram.vue';
import InactiveBenchmarkProgram from './InactiveBenchmarkProgram.vue';
import type { ActiveProgramData, InactiveProgramData, ProgramData } from '@Shared/types/portal/BenchmarkInterfaces';
import type { BaseVisualResult } from '@Shared/utils/types';

interface Props extends BaseVisualResult {
  // getVisualData returns benchmark data in the expected format
  benchmarkData?: Record<string, ProgramData>;
}

const props = defineProps<Props>();

// const benchmarkDataaa = ref<Record<string, ProgramData>>(b);
const benchmarkData = computed(() => props.benchmarkData || {});
const maxDriverCount = computed(() => {
  let max = 0;
  Object.keys(benchmarkData.value).forEach((programKey) => {
    const currentData = benchmarkData.value[programKey];
    if (currentData.isActiveProgram && (currentData as ActiveProgramData).drivers.length > max)
      max = (currentData as ActiveProgramData).drivers.length;
  });
  return max;
});

const getActiveBenchmarkProgramId = (index: number) => `active-program-${index}`;
const getInactiveBenchmarkProgramId = (index: number) => `inactive-program-${index}`;
</script>

<template>
  <div
    :class="[
      'grid gap-6 items-start mx-auto',
      `grid-cols-${Object.keys(benchmarkData).length}`,
      'w-100%',
      'max-w-1500px',
      'min-w-1500px',
    ]"
  >
    <!-- Dynamic grid items using v-for loop -->
    <div
      v-for="([programKey, programData], index) in Object.entries(benchmarkData)"
      :key="programKey"
      class="flex justify-center items-start min-h-[200px] md:min-h-0"
    >
      <ActiveBenchmarkProgram
        v-if="programData.isActiveProgram"
        :data="programData as ActiveProgramData"
        :index="index"
        :max-driver-count="maxDriverCount"
        :id="getActiveBenchmarkProgramId(index)"
      />

      <InactiveBenchmarkProgram
        v-if="!programData.isActiveProgram"
        :data="programData as InactiveProgramData"
        :index="index"
        :max-driver-count="maxDriverCount"
        :standardized-program-name="programKey"
        :id="getInactiveBenchmarkProgramId(index)"
      />
    </div>
  </div>
</template>
